import FeatureFlagsContext from '.';
import { ProviderProps } from './types';

const FeatureFlagsProvider = ({
  children,
  value
}: ProviderProps): JSX.Element => {
  return (
    <FeatureFlagsContext.Provider value={value}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export default FeatureFlagsProvider;
